import { CLOSED, REJECTED } from '@store/skeletor/quoteRequest/states/types';
import { EMPTY_LABEL } from '@utils/text/commonText';

import { DECISION_AREA_ORDER } from './constants';
import { DecisionBadge } from './DecisionBadge';
import type { OperationDecisionBadgesProps } from './types';

const OperationDecisionBadges = ({
  decisions,
  currentStateName,
}: OperationDecisionBadgesProps) => {
  const isClosedOperation =
    currentStateName === CLOSED || currentStateName === REJECTED;
  if (decisions.length === 0) return <span>{EMPTY_LABEL}</span>;

  const sorted = [...decisions].sort(
    (a, b) => DECISION_AREA_ORDER[a.area] - DECISION_AREA_ORDER[b.area],
  );

  return (
    <div className="flex items-center gap-1">
      {sorted.map(decision => (
        <DecisionBadge
          key={decision.area}
          {...decision}
          isClosedOperation={isClosedOperation}
        />
      ))}
    </div>
  );
};

export { OperationDecisionBadges };
